import { GenericLazyString } from '@eventbrite/i18n';
import lodashIsString from 'lodash/isString';
import React, { ComponentProps } from 'react';
import { FrameBasedReadMore } from './FrameBasedReadMore';
import { TextLengthBasedReadMore } from './TextLengthBasedReadMore';

export type ReadMoreProps =
    | ComponentProps<typeof FrameBasedReadMore>
    | ComponentProps<typeof TextLengthBasedReadMore>;

/**
 * Renders content that is collapsed. The criteria to collapse content depends
 * on the kind of content: if you provide some string-like content it will be
 * truncated based on character count, if you provide a React hierarchy it will
 * be truncated based on height (but only work reliable in the client, so
 * users will see a flash and LCP will be affected negatively).
 */
export const ReadMore: React.FunctionComponent<ReadMoreProps> = (props) => {
    const isTextContent = lodashIsString(props.children);

    return isTextContent ? (
        <TextLengthBasedReadMore deviceType="mobile" {...props}>
            {props.children as string | GenericLazyString}
        </TextLengthBasedReadMore>
    ) : (
        <FrameBasedReadMore {...props} />
    );
};
